import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import Text from '../Text';
import { Image } from 'rebass';

const Wrapper = styled.div`
  ${({ float, align }) => {
    return css`
      text-align: center;
      @media (min-width: 768px) {
        float: ${float};
        max-width: 50%;
        margin-left: ${float === 'right' ? '16px' : '0'};
        margin-right: ${float === 'left' ? '16px' : '0'};
        text-align: ${align};
      }
    `;
  }}
`;

const ImageSlice = props => {
  const align = useMemo(() => {
    switch (props.alignment) {
      case 'left':
      case 'center':
      case 'right':
        return props.alignment;
      default:
        return 'unset';
    }
  }, []);
  const float = useMemo(() => {
    switch (props.alignment) {
      case 'float-left':
        return 'left';
      case 'float-right':
        return 'right';
      default:
        return 'unset';
    }
  }, []);
  return (
    <Wrapper align={align} float={float}>
      <Image width={[1, 'unset']} {...props.source} src={props.source.url} />
      {props.caption && (
        <Text width={1} textAlign="center" variant="secondary">
          {props.caption}
        </Text>
      )}
    </Wrapper>
  );
};

export default ImageSlice;
